// Persisted format 1 uses these released keys forever. New keys require a new format decoder.
export const HULL_IDS = [
  "assault",
  "interceptor",
  "engineer",
  "scout",
  "transport",
] as const;
export const WEAPON_IDS = [
  "pulse",
  "laser",
  "missile",
  "flak",
  "rail",
  "ion",
] as const;
export const MODULE_IDS = [
  "barrier",
  "volley",
  "repair",
  "mine",
  "jammer",
  "interceptor",
  "repair-field",
  "scan",
] as const;
export const NPC_ARCHETYPES = [
  "raider",
  "sniper",
  "minelayer",
  "charger",
  "support",
  "disruptor",
  "elite",
  "boss",
  "transport",
  "alien-scout",
  "alien-artillery",
  "alien-disruptor",
] as const;
export const PASSIVE_IDS = [
  "none",
  "targeting",
  "capacitor",
  "repair-drone",
  "thrusters",
] as const;
export const SECTOR_IDS = [
  "patrol",
  "wrecks",
  "frontier",
  "concord-azure",
  "concord-kepler",
  "concord-beacons",
  "concord-aegis",
  "concord-harmony",
  "helion-iron",
  "helion-slag",
  "helion-forge",
  "helion-imperative",
  "helion-rift",
  "nomads-magpie",
  "nomads-graveyard",
  "nomads-mist",
  "nomads-shards",
  "nomads-last-chance",
  "training",
] as const;
export const ORDINARY_NPC_ARCHETYPES = [
  "raider",
  "sniper",
  "minelayer",
  "charger",
  "support",
  "disruptor",
] as const;
